import { put, call, take, fork } from 'redux-saga/effects'
import { generateCardService } from 'src/api/course'
//import { questionPatchSuccess } from '../../reducers/question/action'
import { generateCardSuccess } from 'src/reducers/course/action'
import { GENERATE_CARD } from '../../reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* generateCardFlow(payload) {
  try {
    const { data, callback } = payload

    const response = yield call(generateCardService, data)
    yield put(generateCardSuccess(response.data))
    yield put(operationSuccess())
    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* generateCardWatcher() {
  while (true) {
    const action = yield take(GENERATE_CARD)
    const { payload } = action

    yield fork(generalSaga, generateCardFlow, payload, true)
  }
}
